export const createImages = {
  check: require('./check.svg'),
  edit: require('./edit.svg'),
  letterCase: require('./letterCase.svg'),
  settings: require('./settings.svg'),
  upload: require('./upload.svg'),
  bookmark: require('./bookmark.svg'),
  delete: require('./delete.svg'),
  lock: require('./lock.svg'),
  plus: require('./plus.svg'),
  share: require('./share.svg'),
  reset: require('./reset.svg'),
  eye: require('./eye.svg'),
  lockOpen: require('./lockOpen.svg'),
  send: require('./send.svg'),
  download: require('./download.svg'),
  calendar: require('./calendar.svg'),
  calendar1: require('./calendar-1.svg'),
  calendar3: require('./calendar-3.svg'),
  calendar6: require('./calendar-6.svg'),
  datePicker: require('./datePicker.svg'),
  trash: require('./trash.svg'),
};
